<template>
    <section class="FeaturedAccommodation">
        <figure
            class="FeaturedAccommodation__image lazyload"
            :data-bgset="image"
        />
        <div class="container lap-and-up-py-large relative">
            <div class="FeaturedAccommodation__content">
                <BaseHeading
                    class="h6"
                    :preheading="preheading"
                    :heading="heading"
                    tag="h5"

                />
                <HrLine />

                <h6>{{ item.heading }}</h6>
                <BaseText
                    :text="truncatedText"
                />
                <BaseButton
                    :href="item.url"
                    modifier="small"
                >
                    View details
                </BaseButton>

                <a
                    v-if="!isBuilder"
                    :href="href"
                    class="FeaturedAccommodation__options"

                >
                    <BaseIcon
                        icon="accomm-icon"
                        color="#C9C4BC"
                    />
                    More accommodation options
                </a>
            </div>
        </div>
    </section>
</template>
<script>
import HrLine from '@components/HrLine.vue'
export default {
    name: 'FeaturedAccommodation',
    components: {
        HrLine
    },
    props: {
        image: {
            type: String
        },
        slug: {
            type: String
        },
        preheading: {
            type: String,
            default: 'Featured'
        },
        heading: {
            type: String,
            default: 'Accommodation'
        },
        isBuilder: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        item() {
            return this.$attrs.content[0]
        },
        href() {
            return `/search/accommodation?region=${this.slug}`
        },
        truncatedText() {
            if (this.item && this.item.description) {
                const ellipses = this.item.description.length >= 290 ? '...' : '';

                if (ellipses.includes('<p>')) {
                    return `${this.item.description.slice(0, 290)} ${ellipses}`;
                } else {
                    return `<p>${this.item.description.slice(0, 290)} ${ellipses}</p>`;
                }
            }

            return '';
        }
    }
}
</script>
<style lang="scss" scoped>

    .FeaturedAccommodation {
        position: relative;

        @include media-query(palm) {
            padding-bottom: 3rem;
        }
    }

    .FeaturedAccommodation__image {
        height: 300px;
        width: 100%;
        background-size: cover;
        background-position: center;

        @include media-query(lap-and-up) {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
        }
    }

    .FeaturedAccommodation__content {
        width: 100%;
        background: getColor('white');
        padding: getSpacing('spacer');

        @include media-query(palm) {
            margin-top: -5.75rem;
            box-shadow: 0 10px 35px 0 rgba(0,0,0,0.20);
        }

        @include media-query(lap-and-up) {
            max-width: 450px;
            padding: getSpacing('medium');
        }
    }

    .HrLine {
        padding-left: 0;
        padding-right: 0;
        margin: getSpacing('spacer') 0;
    }

    h6 {
        color: $action-color;
        font-family: $heading-font-family;
        text-transform: uppercase;
        font-size: 1.125rem;

        @include media-query(desk) {
            font-size: 1.2rem;
        }
    }

    .BaseText {
        margin-bottom: getSpacing(spacer);
        margin-top: getSpacing(small);
    }

    .FeaturedAccommodation__options {
        display: flex;
        align-items: center;
        margin-top: getSpacing('large');
        color: $action-color;
        font-weight: 700;
        font-size: 0.75rem;

        &:hover {
            opacity: 0.95;
        }
    }

    .BaseIcon {
        margin-right: 0.5rem;
    }
</style>
